export function ageOnDate(dateOfBirth: string, now = new Date()): number {
  const birth = new Date(`${dateOfBirth}T00:00:00Z`);
  if (Number.isNaN(birth.getTime())) return -1;
  let age = now.getUTCFullYear() - birth.getUTCFullYear();
  const beforeBirthday =
    now.getUTCMonth() < birth.getUTCMonth() ||
    (now.getUTCMonth() === birth.getUTCMonth() && now.getUTCDate() < birth.getUTCDate());
  if (beforeBirthday) age -= 1;
  return age;
}

export function requiresGuardian(dateOfBirth: string, now = new Date()): boolean {
  const age = ageOnDate(dateOfBirth, now);
  return age >= 16 && age < 18;
}

export function calculateShares(
  invoice: number,
  rates: { connector?: number; operator?: number },
) {
  const requested = Object.values(rates).reduce((sum, rate) => sum + (rate ?? 0), 0);
  if (requested - 0.15 > Number.EPSILON) throw new Error("Combined pilot payout cannot exceed 15%.");
  return Object.fromEntries(
    Object.entries(rates).map(([key, rate]) => [key, Math.round(invoice * (rate ?? 0) * 100) / 100]),
  );
}

export function canMinorWork(input: {
  guardianApproved: boolean;
  countryApproved: boolean;
  identityApproved: boolean;
  legalApproved: boolean;
  payoutEligible: boolean;
}) {
  return Object.values(input).every(Boolean);
}
